import type { UndecoratedProduct } from '@witmetrics/utils';
import { sortByKey } from '@witmetrics/utils/arrays';
import { buildProductOption } from '@witmetrics/unison-core';

export const classes = {
  wrapper: 'flex grow items-center',
  textField: 'ml-0 mr-2 pb-0 pt-0 w-[75px] shrink-0',
  productDropdown: 'grow',
  priceInput: 'ml-2 mr-0 flex-0 w-[250px]',
};

export function sortProducts(products: UndecoratedProduct[]) {
  return sortByKey(products.map(buildProductOption), 'label', -1);
}
